export const LOGIN = 'auth/LOGIN'
export const LOGIN_LOADING = 'auth/LOGIN_LOADING'
export const LOGIN_FAILURE = 'auth/LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'auth/LOGIN_SUCCESS'
export const CHECK = 'auth/CHECK'
export const CHECK_PASSED = 'auth/CHECK_PASSED'
export const LOGOUT = 'auth/LOGOUT'



// WEBPACK FOOTER //
// ./state/types/auth.js